import {
  DropdownOptionType,
  DropdownPropsType,
  OptionsAlignmentTypes,
} from '@insurancemenu/imenu-components-lib/dist/types';
import React from 'react';
import { Dropdown } from '@insurancemenu/imenu-components-lib';
import { ChevronDown, ChevronUp } from '@insurancemenu/imenu-components-lib/dist/icons';
import { ButtonClosedStyled, ButtonOpenedStyled, FilterTitle } from './styles';

interface Filter {
  value: string | null;
  label: string;
}

interface Props extends Omit<DropdownPropsType, 'options' | 'name'> {
  filterName: string;
  selectedFilterLabel: string;
  filtersList: Filter[];
  $minWidth?: string;
  applyFilter: (value: string | null) => void;
}

export const FilterDropdown: React.FC<Props> = ({
  filterName,
  selectedFilterLabel,
  filtersList,
  $minWidth,
  applyFilter,
  ...rest
}) => {
  function createOptions(): DropdownOptionType[] {
    return filtersList.map(({ value, label }) => ({
      value,
      label,
      onOptionClick: applyFilter,
    })) as DropdownOptionType[];
  }

  return (
    <Dropdown
      name={filterName}
      openedElement={
        <ButtonOpenedStyled rightIconProp={<ChevronUp />} color="primary" size="large" $minWidth={$minWidth}>
          {filterName} <FilterTitle>{selectedFilterLabel}</FilterTitle>
        </ButtonOpenedStyled>
      }
      closedElement={
        <ButtonClosedStyled rightIconProp={<ChevronDown />} color="primary" size="large" $minWidth={$minWidth}>
          {filterName} <FilterTitle>{selectedFilterLabel}</FilterTitle>
        </ButtonClosedStyled>
      }
      options={createOptions()}
      optionsWidth="27rem"
      optionsAlignment={OptionsAlignmentTypes.BOTTOM_RIGHT}
      {...rest}
    />
  );
};
